import React from 'react';

interface Props {
  courseTitle: string;
  currentTitle?: string;
  progressPercent: number;
  progressLabel: string;
  onBack: () => void;
  backLabel?: string;
}

export default function LearningHeader({
                                         courseTitle,
                                         currentTitle,
                                         progressPercent,
                                         progressLabel,
                                         onBack,
                                         backLabel = 'Back',
                                       }: Props) {
  return (
    <header className="learning-header">
      <div className="learning-header__left">
        <button type="button" className="learning-header__back" onClick={onBack}>
          {backLabel}
        </button>

        <div className="learning-header__titles">
          <div className="learning-header__course">{courseTitle}</div>
          {currentTitle && <div className="learning-header__current">{currentTitle}</div>}
        </div>
      </div>

      <div className="learning-header__right">
        <div className="learning-header__progress-label">{progressLabel}</div>
        <div className="learning-header__progress-bar">
          <div
            className="learning-header__progress-bar-fill"
            style={{ width: `${Math.max(0, Math.min(100, progressPercent))}%` }}
          />
        </div>
      </div>

      <style>{`
        .learning-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          padding: 1rem 1.25rem;
          border-bottom: 1px solid #e5e7eb;
          background: #fff;
        }

        .learning-header__left {
          display: flex;
          align-items: center;
          gap: 1rem;
          min-width: 0;
        }

        .learning-header__back {
          border: 1px solid #d1d5db;
          background: #fff;
          border-radius: 8px;
          padding: 0.5rem 0.875rem;
          cursor: pointer;
          white-space: nowrap;
        }

        .learning-header__titles {
          min-width: 0;
        }

        .learning-header__course {
          font-size: 1rem;
          font-weight: 600;
          color: #111827;
        }

        .learning-header__current {
          font-size: 0.875rem;
          color: #6b7280;
          margin-top: 0.125rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 40rem;
        }

        .learning-header__right {
          min-width: 220px;
          display: flex;
          flex-direction: column;
          gap: 0.375rem;
        }

        .learning-header__progress-label {
          font-size: 0.75rem;
          color: #6b7280;
          text-align: right;
        }

        .learning-header__progress-bar {
          width: 100%;
          height: 8px;
          border-radius: 999px;
          background: #e5e7eb;
          overflow: hidden;
        }

        .learning-header__progress-bar-fill {
          height: 100%;
          background: #2563eb;
          border-radius: 999px;
        }
      `}</style>
    </header>
  );
}